import { NetworkStatus, useMutation, useQuery } from '@apollo/client';
import { Mutation, MutationDeleteQrCodeVisitArgs, QrCodeVisitWeb, Query } from 'graphql/generated/graphqlTypes';
import { DELETE_QR_CODE_VISIT } from 'graphql/v2/mutations';
import { GET_QR_CODE_VISITS_FOR_TENANT } from 'graphql/v2/queries';
import { useRegisterBackgroundRefetch } from 'hooks/useBackgroundRefetch/useBackgroundRefetch';
import { TranslatedHookProps } from 'v2/hooks/hooks.types';

const useQrCodeVisits = ({ handleFetchError, translation }: TranslatedHookProps) => {
  const { data, loading, networkStatus } = useQuery<Pick<Query, 'getQrCodeVisitsForTenant'>>(
    GET_QR_CODE_VISITS_FOR_TENANT,
    {
      notifyOnNetworkStatusChange: true,
      onError: () => handleFetchError(translation.visits_error_fetching)
    }
  );

  const isRefetchingQrCodeVisits = !!data && networkStatus !== NetworkStatus.ready;

  useRegisterBackgroundRefetch(isRefetchingQrCodeVisits);

  const qrCodeVisits: QrCodeVisitWeb[] = data?.getQrCodeVisitsForTenant ?? [];

  const [cancelQrCodeVisitMutation] = useMutation<Pick<Mutation, 'deleteQrCodeVisit'>, MutationDeleteQrCodeVisitArgs>(
    DELETE_QR_CODE_VISIT,
    {
      refetchQueries: [GET_QR_CODE_VISITS_FOR_TENANT],
      awaitRefetchQueries: true
    }
  );

  const cancelQrCodeVisit = async (qrCodeVisitId: string) => {
    await cancelQrCodeVisitMutation({ variables: { qrCodeVisitId } });
  };

  return { qrCodeVisits, loading: loading && !data, isRefetchingQrCodeVisits, cancelQrCodeVisit };
};

export default useQrCodeVisits;
